import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Input, SelectMenu, Text } from "@zorni/components-lib";
import styles from "./GeneralInfoCard.module.css";

const GeneralInfoCard = ({
  establishments,
  establishment,
  setEstablishment,
  generalInfo,
  setGeneralInfo,
  onContinue,
  continueDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.sectionCard}>
      <div className={styles.grid}>
        <div className={styles.formGroup}>
          <SelectMenu t={t}
            name="establishment"
            options={establishments.map((item, idx) => ({
              id: idx,
              value: item?.company?.legalName,
              text: item?.company?.legalName,
              filterText: item?.company?.legalName,
            }))}
            activeSearch={true}
            placeholder={t(
              "tripPublication.addTrip.general.selectEstablishment",
            )}
            value={establishment?.name || ""}
            onChange={(_, option) => {
              const selected = establishments[option.id];
              setEstablishment(
                selected
                  ? { id: selected.id, name: selected.company?.legalName }
                  : {},
              );
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <Input
            floatingLabel
            helperText=""
            inputSize="medium"
            label={t("tripPublication.addTrip.general.tripTitle")}
            name="tripTitle"
            placeholder={t("tripPublication.addTrip.general.tripTitle")}
            type="text"
            value={generalInfo.title}
            onChange={(e) =>
              setGeneralInfo((p) => ({ ...p, title: e.target.value }))
            }
          />
        </div>
        <div className={`${styles.formGroup} ${styles.full}`}>
          <Input
            floatingLabel
            helperText=""
            inputSize="medium"
            label={t("tripPublication.addTrip.general.smallDescription")}
            name="smallDescription"
            placeholder={t("tripPublication.addTrip.general.smallDescription")}
            type="text"
            value={generalInfo.smallDescription}
            onChange={(e) =>
              setGeneralInfo((p) => ({
                ...p,
                smallDescription: e.target.value,
              }))
            }
          />
        </div>
        <div
          className={`${styles.formGroup} ${styles.full} ${styles.floatingTextAreaGroup}`}
        >
          {/* <textarea
            className={`${styles.textArea} ${styles.floatingTextArea}`}
            rows={5}
            value={generalInfo.description}
            onChange={(e) => setGeneralInfo((p) => ({ ...p, description: e.target.value }))}
            placeholder=" "
          />
          <Text as="label" className={styles.floatingTextAreaLabel}>{t("tripPublication.addTrip.general.detailedDescription")}</Text> */}
          <Input
            floatingLabel
            inputSize="medium"
            label={t("tripPublication.addTrip.general.detailedDescription")}
            multiline
            name="detailedDescription"
            onChange={(e) => setGeneralInfo((p) => ({ ...p, description: e.target.value }))}
            rows={5}
            value={generalInfo.description}
          />
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          primary={true}
          className={styles.primaryBtn}
          label={t("tripPublication.addTrip.general.continue")}
          onClick={onContinue}
          disabled={continueDisabled}
        />
      </div>
    </div>
  );
};

export default GeneralInfoCard;
